export default {"src":"/_next/static/media/out_regular.f6b1d436.svg","height":24,"width":24};